import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import usePageMeta from "@/hooks/usePageMeta";

const FORM_ENDPOINT = "https://readdy.ai/api/form/db6akkcbe24agvuu3hm0";

export default function AboutPage() {
  usePageMeta(
    "关于我们 - 最近最新手机中文大全10",
    "了解最近最新手机中文大全10的站点定位、服务内容与联系方式。我们专注中文手机软件合集与最新版本资讯，欢迎通过表单反馈建议。",
  );

  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    const guard = String(formData.get("website_alt") || "").trim();

    if (status === "submitting") return;

    if (guard) {
      setStatus("success");
      setFeedback("");
      form.reset();
      return;
    }

    formData.delete("website_alt");
    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      payload.append(key, value.toString());
    });

    setStatus("submitting");
    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setFeedback("");
        form.reset();
      } else {
        setStatus("error");
        setFeedback(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFeedback("网络异常，提交失败，请稍后重试。");
    }
  };

  const values = [
    { icon: "ri-apps-2-line", title: "丰富的软件合集", desc: "覆盖社交、工具、游戏、生活等多个场景，收录大量热门中文应用。" },
    { icon: "ri-refresh-line", title: "及时的版本资讯", desc: "持续跟踪软件最新版本与更新内容，帮助用户了解改动与特性。" },
    { icon: "ri-layout-grid-line", title: "完整的分类体系", desc: "专业清晰的分类与标签，配合筛选排序，快速定位所需应用。" },
  ];

  const inputClass =
    "w-full h-11 px-3 text-sm rounded-md bg-background-50 border border-background-200 text-foreground-900 placeholder:text-secondary-400 focus:outline-none focus:border-primary-400";

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="w-full max-w-[1240px] mx-auto px-4 md:px-6 pt-6 pb-10">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
            <h1 className="mt-4 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">关于最近最新手机中文大全10</h1>
            <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl">
              我们是一个专注于中文手机软件合集与最新版本下载资讯的平台，面向安卓与 iOS 手机用户，致力于让查找与了解软件变得更简单、更清晰。
            </p>
          </div>
        </div>

        <div className="w-full max-w-[1240px] mx-auto px-4 md:px-6 py-10">
          <section className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {values.map((v) => (
              <div key={v.title} className="bg-background-50 rounded-lg border border-background-200 p-6">
                <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-primary-100 text-primary-600 text-2xl">
                  <i className={v.icon} aria-hidden="true"></i>
                </span>
                <h2 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h2>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </section>

          <section className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-6">
              <div className="bg-background-50 rounded-lg border border-background-200 p-6">
                <h2 className="font-heading text-lg font-bold text-foreground-950">网站定位与服务介绍</h2>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                  最近最新手机中文大全10 提供手机中文软件的浏览、分类、筛选、搜索与详情查看服务。用户可以按分类查找社交、工具、游戏、生活等类型的应用，查看每个软件的版本号、更新时间、软件大小、支持平台、开发者信息与功能介绍，并了解历次版本更新历史。
                </p>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                  我们尽力保证展示信息的完整与清晰，帮助用户快速判断软件是否符合需求。网站内容会持续更新，努力覆盖最新版本与真实使用场景。
                </p>
              </div>

              <div className="bg-background-50 rounded-lg border border-background-200 p-6">
                <h2 className="font-heading text-lg font-bold text-foreground-950">使用说明与版权声明</h2>
                <ul className="mt-3 space-y-2.5 text-sm text-foreground-700 leading-relaxed">
                  <li className="flex items-start gap-2">
                    <span className="flex items-center justify-center w-4 h-4 mt-1 text-accent-500 shrink-0"><i className="ri-checkbox-circle-line" aria-hidden="true"></i></span>
                    本站为信息与体验演示站点，页面中的下载按钮仅作跳转演示，不提供真实安装包下载，也不统计下载行为。
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="flex items-center justify-center w-4 h-4 mt-1 text-accent-500 shrink-0"><i className="ri-checkbox-circle-line" aria-hidden="true"></i></span>
                    请通过应用商店或软件官方网站获取正版软件，尊重软件版权与开发者劳动成果。
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="flex items-center justify-center w-4 h-4 mt-1 text-accent-500 shrink-0"><i className="ri-checkbox-circle-line" aria-hidden="true"></i></span>
                    站内展示的软件名称、介绍与评论均为示例内容，仅供学习与体验使用。
                  </li>
                </ul>
              </div>

              <div className="bg-background-50 rounded-lg border border-background-200 p-6">
                <h2 className="font-heading text-lg font-bold text-foreground-950">联系方式</h2>
                <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                  <div className="flex items-center gap-2.5 text-foreground-700">
                    <span className="flex items-center justify-center w-5 h-5 text-primary-600"><i className="ri-mail-line" aria-hidden="true"></i></span>
                    support@shoujidaquan10.example.com
                  </div>
                  <div className="flex items-center gap-2.5 text-foreground-700">
                    <span className="flex items-center justify-center w-5 h-5 text-primary-600"><i className="ri-time-line" aria-hidden="true"></i></span>
                    周一至周五 9:00-18:00
                  </div>
                </div>
              </div>
            </div>

            <div id="feedback" className="lg:col-span-1">
              <div className="bg-background-100 rounded-lg border border-background-200 p-6 lg:sticky lg:top-20">
                <h2 className="font-heading text-lg font-bold text-foreground-950">意见反馈</h2>
                <p className="mt-2 text-sm text-foreground-600">你希望看到哪些软件或功能？欢迎留下建议，我们会认真阅读。</p>

                <form data-readdy-form id="about-feedback-form" onSubmit={handleSubmit} className="mt-4 space-y-3">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="form-guard"
                  />
                  <div>
                    <label htmlFor="fb-name" className="block text-xs text-foreground-700 mb-1.5">称呼</label>
                    <input id="fb-name" name="name" type="text" placeholder="请输入你的称呼" className={inputClass} />
                  </div>
                  <div>
                    <label htmlFor="fb-email" className="block text-xs text-foreground-700 mb-1.5">邮箱</label>
                    <input id="fb-email" name="email" type="email" required placeholder="用于接收回复，可选" className={inputClass} />
                  </div>
                  <div>
                    <label htmlFor="fb-type" className="block text-xs text-foreground-700 mb-1.5">反馈类型</label>
                    <select id="fb-type" name="type" className={inputClass} defaultValue="软件收录">
                      <option value="软件收录">软件收录建议</option>
                      <option value="功能建议">功能建议</option>
                      <option value="问题反馈">问题反馈</option>
                      <option value="合作洽谈">合作洽谈</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="fb-content" className="block text-xs text-foreground-700 mb-1.5">反馈内容</label>
                    <textarea
                      id="fb-content"
                      name="content"
                      rows={4}
                      maxLength={500}
                      required
                      placeholder="请描述你的建议或遇到的问题（最多 500 字）"
                      className="w-full px-3 py-2.5 text-sm rounded-md bg-background-50 border border-background-200 text-foreground-900 placeholder:text-secondary-400 focus:outline-none focus:border-primary-400 resize-none"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={status === "submitting"}
                    className="w-full flex items-center justify-center gap-2 h-11 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                  >
                    <span className="flex items-center justify-center w-4 h-4"><i className="ri-send-plane-line" aria-hidden="true"></i></span>
                    {status === "submitting" ? "提交中…" : "提交反馈"}
                  </button>

                  {status === "success" && (
                    <p className="flex items-center gap-1.5 text-xs text-primary-700 bg-primary-100 rounded-md px-3 py-2">
                      <span className="flex items-center justify-center w-4 h-4"><i className="ri-checkbox-circle-line" aria-hidden="true"></i></span>
                      提交成功，感谢你的反馈！
                    </p>
                  )}
                  {status === "error" && (
                    <p className="flex items-center gap-1.5 text-xs text-accent-700 bg-accent-100 rounded-md px-3 py-2">
                      <span className="flex items-center justify-center w-4 h-4"><i className="ri-error-warning-line" aria-hidden="true"></i></span>
                      {feedback}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}